import React from "react";
import { useLang, useSettings } from "../lib/providers";
import { ArrowRight } from "lucide-react";

export default function Upsell() {
  const { lang } = useLang();
  const { settings } = useSettings();
  if (!settings.dz_shopper_enabled) return null;
  const title = lang === "ar" ? settings.dz_shopper_title_ar : settings.dz_shopper_title_fr;
  const desc = lang === "ar" ? settings.dz_shopper_desc_ar : settings.dz_shopper_desc_fr;
  const cta = lang === "ar" ? settings.dz_shopper_cta_ar : settings.dz_shopper_cta_fr;

  return (
    <section className="py-20 sm:py-28 relative overflow-hidden theme-section" data-testid="upsell-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative border-2 border-neon/60 bg-gradient-to-br from-clay/15 via-transparent to-neon/15 p-8 sm:p-12 lg:p-16 shadow-[0_0_60px_-15px_rgba(217,255,0,0.35)]">
          <div className="absolute -top-6 start-8 bg-neon text-black px-4 py-1.5 text-[11px] font-black tracking-[0.25em] uppercase flex items-center gap-2 shadow-lg">
            <span className="w-1.5 h-1.5 bg-black rounded-full animate-pulse" />
            DZ Shopper
          </div>
          <h2 className="font-heading font-black uppercase tracking-tighter text-3xl sm:text-5xl max-w-3xl">{title}</h2>
          {settings.dz_shopper_darija && (
            <p className="mt-3 font-heading text-lg sm:text-2xl text-clay font-bold">{settings.dz_shopper_darija}</p>
          )}
          <p className="mt-6 text-white/70 max-w-2xl text-sm sm:text-base">{desc}</p>
          <a
            href={settings.dz_shopper_url || "/dz-shopper"}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 mt-8 bg-neon text-black hover:opacity-90 hover:scale-[1.03] px-7 py-5 font-black uppercase tracking-widest text-sm sm:text-base transition-all shadow-lg shadow-neon/20"
            data-testid="upsell-cta"
          >
            {cta}<ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
